var exports = {
  "jD": "x9245d464--120d0a--breadcrumbs",
  "QF": "x9245d464--120d0a--breadcrumb",
  "QX": "x9245d464--120d0a--breadcrumbs-link",
  "Fg": "x9245d464--120d0a--breadcrumbs-delimiter",
};

module.exports = exports;
